import React from 'react'
import PropTypes from 'prop-types'

import { Context } from '../../../configs/state.manager'

import { transactionTransform } from '../../../transforms/transaction.transform'

import InvoiceExpendable from '../../common/invoice/invoice-expendable/InvoiceExpendable'
import InvoiceItem from '../../common/invoice/invoice-item/InvoiceItem'
import InvoiceTotal from '../../common/invoice/invoice-total/InvoiceTotal'

const LeaseInvoice = ({ version }) => {
    const {
        state: {
            paymentOptions: { transactionSummary },
        },
    } = React.useContext(Context)

    if (!transactionSummary || !Object.entries(transactionSummary).length) return null

    const transactionFormat = transactionTransform(transactionSummary)

    return (
        <div className='pc-leaseInvoice'>
            {transactionFormat.map((item) => {
                if (!Object.entries(item).length) return null

                const { isExpandable, category, name, amount, isCardLayout, code, isLast } = item

                if (isLast) return <InvoiceTotal key={category} slug={category} label={name} amount={amount} />

                if (isExpandable && code !== 'S5' && code !== 'S7')
                    return <InvoiceExpendable key={category} item={item} version={version} />

                return <InvoiceItem key={category} slug={category} label={name} amount={amount} isCardLayout={!!isCardLayout} />
            })}
        </div>
    )
}

LeaseInvoice.propTypes = {
    version: PropTypes.string,
}

LeaseInvoice.defaultProps = {
    version: 'alpha',
}

export default LeaseInvoice
